import React, { Component, useEffect } from 'react'
import NumberFormat from "react-number-format";
import { connect } from 'react-redux'
import $ from 'jquery';
import { createPaymentPages } from '../../../state/ducks/payment/types';
import { binSearch, addPaymentPayTr, getPaymentPlanePayTr } from "../../../services/payment.service";
import AppCustomSelect from '../shared/AppCustomSelect';
import { setCustomSelectFieldState } from '../../../utils/customSelect';

function ValidateCreditCardNumber() {

    var ccNum = document.getElementById("cardNo").value.replace(/\D/g, '');
    var visaRegEx = /^(?:4[0-9]{12}(?:[0-9]{3})?)$/;
    var mastercardRegEx = /^(?:5[1-5][0-9]{14})$/;
    var amexpRegEx = /^(?:3[47][0-9]{13})$/;
    var discovRegEx = /^(?:6(?:011|5[0-9][0-9])[0-9]{12})$/;
    var troyRegEx = /^(?:9[0-9]{12}(?:[0-9]{3})?)$/;
    var isValid = false;

    if (visaRegEx.test(ccNum)) {
        isValid = true;
    } else if (mastercardRegEx.test(ccNum)) {
        isValid = true;
    } else if (amexpRegEx.test(ccNum)) {
        isValid = true;
    } else if (discovRegEx.test(ccNum)) {
        isValid = true;
    } else if (troyRegEx.test(ccNum)) {
        isValid = true;
    }

    if (isValid) {
        return true;
    } else {
        return false;
    }
}



export class CreditCardPayTR extends Component {

    state = {
        // cc_owner: "PAYTR TEST",
        // card_number: "4355084355084358",
        // expiry_month: "12",
        // expiry_year: "30",
        // cvv: "000",
        // card_type: "axess",


        cc_owner: "",
        card_number: "",
        expiry_month: "",
        expiry_year: "",
        cvv: "",
        card_type: "",
        bank: "",
        bankCode: "",
        businessCard: "",

        installment_count: 0,

        uyeno_hatamesaj: "",
        cardAdi_hatamesaj: "",
        cardNo_hatamesaj: "",
        cardTarih_hatamesaj: "",
        cardCvv_hatamesaj: "",

        installment_list: [],

        amount: 0.00,

        page: "creditCard",
        smsResponse: "",
        error: "",
    };

    onSubmit = e => {
        e.preventDefault();
        if (this.formKontrol() == 0) {
            return false;
        }

        this.cardAddPaymentPayTr();
    }

    formKontrol() {
        var cardAdi = $("#cardAdi").val();
        var cardNo = $("#cardNo").val();
        const { creditcard } = this.props;
        var cardTarih = creditcard.expirationMonth;
        var cardTarihYıl = creditcard.expirationYear;
        var cardCvv = $("#cardCvv").val();
        var durum = 1;
        // kuruş alanı boş ise kuruş 00 olduğu kabul edilir. O sebep ile kontrol dışı.
        // var patternCredit = /^(?:(4[0-9]{12}(?:[0-9]{3})?)|(5[1-5][0-9]{14})|(6(?:011|5[0-9]{2})[0-9]{12})|(3[47][0-9]{13})|(3(?:0[0-5]|[68][0-9])[0-9]{11})|((?:2131|1800|35[0-9]{3})[0-9]{11}))$/;
        // var sdurum = patternCredit.test(cardNo.replace(/\D/g, ''));
        // Card Adı boş mu dolu mu ?


        if (cardAdi == "") {
            durum = 0; // Konu Boş
            $("#cardAdi").parent().addClass("t-error");
            $("#cardAdi").next().html("<i class='t-icon-error text-danger'></i>");
            // $("#cardAdi_hatamesaj").html("Kart Adı alanı boş bırakılamaz.");
            this.setState({ cardAdi_hatamesaj: "Kart Adı alanı boş bırakılamaz." });

        } else {
            $("#cardAdi").parent().removeClass("t-error");
            $("#cardAdi").next().html("<i class='t-icon-check_circle_outline text-success'></i>");
            // $("#cardAdi_hatamesaj").html("");
            this.setState({ cardAdi_hatamesaj: "" });
        }
        // Card No boş mu dolu mu ?
        if (cardNo == "") {
            durum = 0; // Konu Boş
            $("#cardNo").parent().addClass("t-error");
            $("#cardNo").next().html("<i class='t-icon-error text-danger'></i>");
            // $("#cardNo_hatamesaj").html("Kart Numarası alanı boş bırakılamaz.");
            this.setState({ cardNo_hatamesaj: "Kart Numarası alanı boş bırakılamaz." });
        } else {
            if (ValidateCreditCardNumber() == false) {
                durum = 0;
                $("#cardNo").parent().addClass("t-error");
                $("#cardNo").next().html("<i class='t-icon-error text-danger'></i>");
                // $("#cardNo_hatamesaj").html("Kart Numarasını kontrol ediniz.");
                this.setState({ cardNo_hatamesaj: "Kart Numarasını kontrol ediniz." });
            }
            else {

                $("#cardNo").parent().removeClass("t-error");
                $("#cardNo").next().html("<i class='t-icon-check_circle_outline text-success'></i>");
                // $("#cardNo_hatamesaj").html("");
                this.setState({ cardNo_hatamesaj: "" });
            }
        }
        // Card Tarih boş mu dolu mu ?
        if (cardTarih == "" || cardTarihYıl == "") {
            durum = 0;

            setCustomSelectFieldState("cardTarihYıl", true);
            this.setState({ cardTarih_hatamesaj: "Tarih alanı boş bırakılamaz." });
        } else {
            setCustomSelectFieldState("cardTarihYıl", false);
            this.setState({ cardTarih_hatamesaj: "" });
        }

        const cardCvvNumber = cardCvv.replace(' ', '');
        // Card CVV boş mu dolu mu ?
        if (cardCvv == "") {
            durum = 0; // Konu Boş
            $("#cardCvv").parent().addClass("t-error");
            $("#cardCvv").next().html("<i class='t-icon-error text-danger'></i>");
            // $("#cardCvv_hatamesaj").html("CVV alanı boş bırakılamaz.");
            this.setState({ cardCvv_hatamesaj: "CVV alanı boş bırakılamaz." });
        } else if (cardCvvNumber.length < 3) {
            durum = 0; // Konu Boş
            $("#cardCvv").parent().addClass("t-error");
            $("#cardCvv").next().html("<i class='t-icon-error text-danger'></i>");
            // $("#cardCvv_hatamesaj").html("CVV alanı boş bırakılamaz.");
            this.setState({ cardCvv_hatamesaj: "CVV alanı 3 karakterden oluşmalıdır." });
        } else {
            $("#cardCvv").parent().removeClass("t-error");
            $("#cardCvv").next().html("<i class='t-icon-check_circle_outline text-success'></i>");
            // $("#cardCvv_hatamesaj").html("");
            this.setState({ cardCvv_hatamesaj: "" });
        }

        const { orderdetail } = this.props;
        if (orderdetail.paymentType == 2 && orderdetail.installmentCount < 2 && this.state.installment_list.length > 0) {
            durum = 0; // Taksit seçilmemiş
            this.setState({ installmentCount_hatamesaj: "Ödeme planından taksit seçeneğini seçiniz." });
        } else {
            this.setState({ installmentCount_hatamesaj: "" });
        }

        return durum;

    }

    cardNoControl(_bank, _bankCode, _businessCard, _card_type, _message, _isError) {

        this.setState({ card_type: _card_type });
        this.setState({ bank: _bank });
        this.setState({ bankCode: _bankCode });
        this.setState({ businessCard: _businessCard });
        this.cardgetPaymentPlanePayTr();

        if (_isError == true) {
            $("#cardNo").parent().addClass("t-error");
            $("#cardNo").next().html("<i class='t-icon-error text-danger'></i>");
            this.setState({ cardNo_hatamesaj: _message });
        }
        else {

            $("#cardNo").parent().removeClass("t-error");
            $("#cardNo").next().html("<i class='t-icon-check_circle_outline text-success'></i>");
            this.setState({ cardNo_hatamesaj: "" });
        }
    }


    cardBinSearch() {
        if (this.state.card_number.length > 7) {
            binSearch(this.state.card_number).then(
                response => {
                    if (response.responseCode == 200 && response.data != null) {
                        const { orderdetail } = this.props;
                        if (response.data.brand == "none" && orderdetail.paymentType == 2) {
                            this.cardNoControl("","","","", "Bu kart ile taksitli işlem yapılamaz.", true);
                        } else {
                            this.cardNoControl(response.data.bank, response.data.bankCode, response.data.businessCard, response.data.brand, "", false);
                        }
                    } else {
                        if (response.messages.length > 0) {
                            this.cardNoControl("","","","", response.messages[0], true);
                        } else {
                            this.cardNoControl("","","","", "Geçersiz kart numarası.", true);
                        }
                    }
                },
                error => {
                    this.cardNoControl("","","","", "Kart numarası sorgulanamadı.", true);
                }
            );
        } else {
            this.state.card_type = "";
            this.setState({ card_type: "" });
            this.state.bank = "";
            this.setState({ bank: "" });
            this.state.bankCode = "";
            this.setState({ bankCode: "" });
            this.state.businessCard = "";
            this.setState({ businessCard: "" });
            this.cardgetPaymentPlanePayTr();
        }
    }

    cardAddPaymentPayTr() {

        this.props.creditcard.cardType = this.state.card_type;
        this.props.creditcard.bank = this.state.bank;
        this.props.creditcard.bankCode = this.state.bankCode;
        this.props.creditcard.businessCard = this.state.businessCard;
        this.props.createPaymentPayFor();
    }

    cardgetPaymentPlanePayTr() {
        const { creditcard, orderdetail } = this.props;

        getPaymentPlanePayTr(this.state.amount, this.state.card_type, orderdetail.paymentType, this.state.bank, this.state.bankCode, this.state.businessCard, orderdetail.memberNo).then(
            response => {
                this.setState({ installment_list: response.data });
                if (response.data.length > 0) {
                     if (orderdetail.paymentType == 1) {
                            this.state.installment_count = response.data[0].value;
                            this.props.orderdetail.installmentCount = response.data[0].value;
                        }
                        else {
                            this.state.installment_count = 0;
                            this.props.orderdetail.installmentCount = 0;
                        }
                }
                else{
                    this.props.orderdetail.installmentCount = -3;
                }
            },
            error => { }
        );
    }

    componentDidMount() {

        const { creditcard, orderdetail } = this.props;
        // this.cardgetPaymentPlanePayTr();

        var cardNo = $("#cardNo").val();
        this.state.card_number = cardNo;
        this.cardBinSearch();

    }

    setInstallment(event) {
        this.setState({ installment_count: parseFloat(event.target.value) });

        $('.installment-row.installment-chacked').removeClass('installment-chacked');
        document.querySelector('input[name="installment_count"]:checked').parentElement.parentElement.classList.add('installment-chacked');
    }

    render() {

        const { creditcard, orderdetail } = this.props;
        var dt = new Date();
        const yearArray = Array.from({ length: 13 }, (_, i) => dt.getFullYear() + i);

        this.state.amount = parseFloat(orderdetail.aylikTutar + '.' + orderdetail.aylikTutarOndalik)


        var page = this.state.page;
        if (page == "sms") {
            return (
                <div className="container-fluid">
                    <div className="row" style={{ padding: "3%" }}>
                        <div className="col-12">
                            <iframe width="100%"
                                height="640px" frameBorder="0" src={"data:text/html," + encodeURIComponent(this.state.smsResponse)} />
                        </div>
                    </div>
                </div>
            )
        }
        else {
            return (

                <form id="paymentForm" action="https://www.paytr.com/odeme" method="post">

                    <div className="row" style={{ padding: "3%" }}>
                        <div className="col-12">
                            {/* KUTU 1 */}
                            <div className="row no-gutters t-kutu t-yesilCizgi">
                                <div
                                    className="col  backtop"
                                    style={{
                                        backgroundImage: 'url("/assets/img/backgrounds/back_top_yesil.jpg")'
                                    }}
                                >
                                    {/* içerikler */}
                                    {/* Başlık */}
                                    <div className="row no-gutters pb-4 bosluk">
                                        <div clss="col-auto">
                                            <i className="t-icon-credit-card  icon" />
                                        </div>
                                        <div className="col d-flex flex-column justify-content-center">
                                            <div className="baslik" style={{ padding: "0 0 5px 0" }}>
                                                Ödeme Talimatı
                                            </div>
                                            <span className="altBaslik">Ödeme Talimatı Verme</span>
                                        </div>
                                    </div>
                                    {/* KART */}
                                    <div className="row no-gutters" style={{ padding: "0 10%" }}>
                                        <div className="col-12 pb-2 t-icBaslikTuruncu">
                                            KART BİLGİLERİNİ GİRİNİZ
                                        </div>
                                        <div className="col-12 t-icHatirlatmaYazisi">
                                            Kart bilgileriniz sadece sizin bankanızda saklanır. Emin Üstün
                                            Holding dahil bankanız haricinde kimse tarafından görülemez.
                                        </div>
                                        {this.state.error !== "" ?
                                            <div className="col-12 pt-4 pb-4 t-icHatirlatmaYazisi" style={{ color: "red", fontWeight: "bold" }}>
                                                {this.state.error}
                                            </div> : <span></span>}
                                    </div>
                                    <div className="row no-gutters pb-2" style={{ padding: "0 10%" }}>




                                        <div className="col-12 pb-1">
                                            <span className="t-icInputTitle pl-3">Kart Sahibi</span>
                                        </div>
                                        {/* Kartın Üzerindeki İsim*/}
                                        <div className="col-12">
                                            <div className="t-icInput">
                                                <div>
                                                    <i className="t-icon-user1" />
                                                </div>

                                                <input type="text"
                                                    id="cardAdi"
                                                    name='cc_owner'
                                                    maxLength="50"
                                                    pattern="^\s*[a-zA-Z,ç,Ç,ğ,Ğ,ı,İ,ö,Ö,ş,Ş,ü,Ü,\s]+\s*$"
                                                    title="Sadece türkçe karakter girmelisiniz."
                                                    placeholder="Kartın Üzerindeki İsimi Yazınız"
                                                    value={creditcard.cardHolderName}
                                                    onChange={e => {
                                                        creditcard.cardHolderName = e.target.value;
                                                        this.setState({ cc_owner: e.target.value });

                                                    }} />
                                                <div />
                                            </div>
                                        </div>
                                        {/* Hata mesajının geleceği alan*/}
                                        {this.state.cardAdi_hatamesaj == "" ? null :
                                            <div
                                                className="col-12 t-icinputHatamesajArea pl-3 pt-1"
                                                id="cardAdi_hatamesaj"
                                            >{this.state.cardAdi_hatamesaj}</div>
                                        }

                                        <div className="col-12 pb-1 pt-2">
                                            <span className="t-icInputTitle pl-3">Kart Numarası</span>
                                        </div>
                                        {/* Kart Numarası*/}
                                        <div className="col-12">
                                            <div className="t-icInput">
                                                <div>
                                                    {this.state.card_type == "" || this.state.card_type == "none" ? <i className="t-icon-credit_card " /> :
                                                        <img src={`https://www.paytr.com/img/odeme_sayfasi/${this.state.card_type}.png`} alt={this.state.card_type} width={40}></img>
                                                    }
                                                </div>

                                                <NumberFormat
                                                    displayType={"input"}
                                                    format="####-####-####-####"
                                                    name='card_number'
                                                    id="cardNo"
                                                    className="cardNo"
                                                    title="Hatalı kart numarası"
                                                    value={creditcard.cardNumber}
                                                    onChange={e => {
                                                        this.state.card_number = e.target.value.trim();
                                                        creditcard.cardNumber = e.target.value.trim();
                                                        this.cardBinSearch();
                                                    }} />
                                                <div />
                                            </div>
                                        </div>

                                        {/* Hata mesajının geleceği alan*/}
                                        {this.state.cardNo_hatamesaj == "" ? null :
                                            <div
                                                className="col-12 t-icinputHatamesajArea pl-3 pt-1"
                                                id="cardNo_hatamesaj"
                                            >{this.state.cardNo_hatamesaj}</div>
                                        }

                                        {/* Kart Son kullanım Tarihi*/}
                                        <div className="col-12 col-md-6 pr-1 pt-2">
                                            <span className="t-icInputTitle pl-3 pb-2">
                                                Son Kullanım Tarihi
                                            </span>
                                            <div className="t-icInput">
                                                <div>
                                                    <i className="t-icon-calendar1" />
                                                    &nbsp;&nbsp;
                                                </div>

                                                <AppCustomSelect
                                                    id="cardTarih"
                                                    className="t-eminPayCustomSelect--expiryMonth"
                                                    value={creditcard.expirationMonth}
                                                    options={Array.from({ length: 12 }, (_, i) => i + 1).map((item) => ({
                                                        value: String(item),
                                                        label: String(item),
                                                    }))}
                                                    onChange={(nextValue) => {
                                                        creditcard.expirationMonth = nextValue;
                                                        this.setState({ expiry_month: nextValue });
                                                    }}
                                                />
                                                <div />
                                                &nbsp;&nbsp;
                                                <AppCustomSelect
                                                    id="cardTarihYıl"
                                                    className="t-eminPayCustomSelect--expiryYear"
                                                    value={creditcard.expirationYear}
                                                    options={yearArray.map((item) => ({
                                                        value: String(item),
                                                        label: String(item),
                                                    }))}
                                                    onChange={(nextValue) => {
                                                        creditcard.expirationYear = nextValue;
                                                        this.setState({ expiry_year: nextValue });
                                                    }}
                                                />
                                                <div>

                                                </div>
                                            </div>
                                            {/* Hata yeri*/}
                                            {this.state.cardTarih_hatamesaj == "" ? null :
                                                <div
                                                    className="col-12 t-icinputHatamesajArea pl-3 pt-1"
                                                    id="cardTarih_hatamesaj"
                                                >{this.state.cardTarih_hatamesaj}</div>
                                            }
                                        </div>

                                        <div className="col-12 col-md-6 pl-1 pt-2 pb-3">
                                            <span className="t-icInputTitle pl-3 pb-2">CVV Kodu</span>
                                            <div className="t-icInput">
                                                <div>
                                                    <i className="t-icon-credit-card" />
                                                </div>

                                                <NumberFormat
                                                    displayType={"input"}
                                                    format="###"
                                                    pattern="^[0-9]*$"

                                                    type="text"
                                                    id="cardCvv"
                                                    name='cvv'
                                                    className="cardCvv"
                                                    maxLength="50"
                                                    // maxlength="3" 
                                                    required
                                                    value={creditcard.cvv}
                                                    onChange={e => {
                                                        creditcard.cvv = e.target.value
                                                        this.setState({ cvv: e.target.value });

                                                    }} />
                                                <div />
                                            </div>
                                            {/* Hata Yeri*/}
                                            {this.state.cardCvv_hatamesaj == "" ? null :
                                                <div
                                                    className="col-12 t-icinputHatamesajArea pl-3 pt-1"
                                                    id="cardCvv_hatamesaj"
                                                >{this.state.cardCvv_hatamesaj}</div>
                                            }
                                        </div>

                                        {/* Taksit */}
                                        {orderdetail.paymentType == 2 ?
                                            <div className='col-12'>
                                                <div className="col-12 col-md-6 pr-1">
                                                    <span className="t-icInputTitle pl-3 pb-2">
                                                        Ödeme Planı
                                                    </span>
                                                </div>

                                                

                                            {/* Hata Yeri*/}
                                            {this.state.installmentCount_hatamesaj == "" ? null :
                                                <div
                                                    className="col-12 t-icinputHatamesajArea pl-3 pt-1"
                                                    id="installmentCount_hatamesaj"
                                                >{this.state.installmentCount_hatamesaj}</div>
                                            }

                                                <div className='col-12 p-2 mb-3' style={{ fontSize: "12pt", backgroundColor: "#f7f7f7" }}
                                                    //onChange={this.setInstallment.bind(this)}
                                                    onChange={e => {
                                                        this.setState({ installment_count: parseFloat(e.target.value) });
                                                        orderdetail.installmentCount = parseFloat(e.target.value);
                                                        $('.installment-row.installment-chacked').removeClass('installment-chacked');
                                                        document.querySelector('input[name="installment_count"]:checked').parentElement.parentElement.classList.add('installment-chacked');
                                                    }}
                                                >
                                                    <div className='col-12 pb-1'>
                                                        <div className='row text-success' style={{ height: "30px", borderBottom: "solid 1px" }}>
                                                            <div className='col-1'></div>
                                                            <div className="col-3 text-center">Taksit Sayısı</div>
                                                            <div className="col-4 text-center">Taksit Tutarı</div>
                                                            <div className="col-4 text-center">Toplam Ödeme</div>
                                                        </div>
                                                    </div>

                                                    {this.state.installment_list.length > 0 ? this.state.installment_list.map((installment_item) => (

                                                        <div className='col-12' key={installment_item.count} >
                                                            <label className={`row installment-row ${installment_item.checked ? 'installment-chacked' : ''} p-1`}>
                                                                <div className='col-1 text-center'>
                                                                    <input type='radio' value={installment_item.value} name='installment_count' defaultChecked={installment_item.checked} />
                                                                </div>
                                                                <div className='col-3 text-center'>{installment_item.count}</div>
                                                                <div className='col-4 text-center'>{installment_item.amount}</div>
                                                                <div className='col-4 text-center'>{installment_item.total}</div>
                                                            </label>
                                                        </div>
                                                    )) : null}

                                                </div>
                                            </div> : <span></span>
                                        }

                                        {/* Button */}
                                        <div className="col-12 d-flex justify-content-center">
                                            <button className="t-icButonTrunucu mr-1" onClick={() => this.props.changePage(createPaymentPages.orderDetail)}>
                                                <i className="t-icon-arrow-left2" />
                                                <span>Geri</span>
                                            </button>

                                            <button className="t-icButtonYesil ml-1" onClick={this.onSubmit}>
                                                <span>Devam</span>
                                                <i className="t-icon-arrow-right2" />
                                            </button>
                                        </div>

                                    </div>

                                    <div id="paytr_taksit_tablosu"></div>

                                    {/* STEP LER */}
                                    <div className="row no-gutters pt-4 pb-4 justify-content-center align-items-start">
                                        {/* cizgi*/}
                                        <div className="col-1 t-cizgiBackgroundKenar" />
                                        {/* 1*/}
                                        <div className="col-auto t-icStepPasif">
                                            <div className="ortala">
                                                <div className="yuvarlak">1</div>
                                            </div>
                                            <span>Ödeme Bilgileri</span>
                                        </div>
                                        {/* cizgi*/}
                                        <div className="col-auto t-cizgiBackgroundOrta" />
                                        {/* 2*/}
                                        <div className="col-auto t-icStepAktif">
                                            <div className="ortala">
                                                <div className="yuvarlak">2</div>
                                            </div>
                                            <span>Kart Bilgileri</span>
                                        </div>
                                        {/* cizgi*/}
                                        <div className="col-auto t-cizgiBackgroundOrta" />
                                        {/* 2*/}
                                        <div className="col-auto t-icStepPasif">
                                            <div className="ortala">
                                                <div className="yuvarlak">3</div>
                                            </div>
                                            <span>Onay</span>
                                        </div>
                                        {/* cizgi*/}
                                        <div className="col-1 t-cizgiBackgroundKenar" />
                                    </div>
                                    {/* içerikler BİTTİ */}
                                    <div className="row no-gutters pt-0 pb-4 justify-content-center align-items-start">
                                        . . .
                                    </div>
                                </div>
                                <div className="col-auto renk" />
                            </div>
                            {/* KUTU 1 BİTTİ */}
                        </div>

                    </div>
                </form>
            )
        };
    }
}

const mapStateToProps = (state) => ({

})

const mapDispatchToProps = dispatch => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(CreditCardPayTR)
